<template>
  <div>
    <Card
      :bordered="false"
      :dis-hover="true"
    >
    <Table :columns="columns" :data="data"></Table>
    </Card>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'depositExamineExtra',
  props: {
    flowDetail: {
      type: Object
    },
    flowInstance: {
      type: Object
    }
  },
  data() {
    return {
      columns: [
        {
          title: '汇款单位',
        },
        {
          title: '报名单位',
        },
        {
          title: '包组',
        },
        {
          title: '中标',
        },
        {
          title: '领取金额',
        },
        {
          title: '文件',
          render: (h, params) => {
            return h('div', params.row.fileId)
          }
        },
        {
          title: '备注',
          key: 'comment'
        }
      ],
      data: []
    }
  },
  methods: {
    async getFlowLog() {
      let rep = await ajax.get(requestUrls.AbpFlowLog.GetPaged, {
        params: {
          filter: `workFlowId==${this.flowInstance.WorkflowInstanceId}`,
          sorting: '',
          maxResultCount: 100,
          skipCount: 0
        }
      })
      this.data = []
      if (rep.data.success) {
        this.data = rep.data.result.items
      }
    }
  },
  watch: {
    flowInstance: {
      handler(val) {
        this.getFlowLog()
      },
      immediate: true
    }
  }
}
</script>
